import LocalStorageService from 'src/services/LocalStorageService'
import { createLastUsedLocalStorageKey } from 'src/utils/helpers'

export const getLastUsedStorageKey = (dictionaryName, locationType, userId) =>
  `${createLastUsedLocalStorageKey(dictionaryName, locationType)}:${encodeURIComponent(
    String(userId === null || userId === undefined ? 'anonymous' : userId)
  )}`

export const readLastUsedArray = key => {
  try {
    const savedValue = LocalStorageService.get(key)
    if (!savedValue) return []

    const value = JSON.parse(savedValue)
    if (Array.isArray(value)) {
      return value.filter(
        item => item && typeof item === 'object' && !Array.isArray(item)
      )
    }
  } catch (error) {
    // Invalid or unavailable storage should not break offer filters.
  }

  try {
    LocalStorageService.remove(key)
  } catch (error) {
    // Storage can be unavailable in private browsing modes.
  }
  return []
}

export const writeLastUsedArray = (key, items) => {
  try {
    LocalStorageService.set(key, JSON.stringify(items))
  } catch (error) {
    // The current selection can still work when storage is unavailable.
  }
}
